import { Usuario } from "./usuario.model";

export class CursosComprados {

    _id: string;
    tituloCurso: string;
    descripcionCurso: string;
    valor:string;
    horario:string;
    categorias: string;
    usuario: Usuario
    estado: String;
    emailusuario:String
    telefono: String
   }